// Copyright ©️ 2026 eVolve MEP, LLC

import { createModalRegistry } from 'components/Mantine/Modals/createModalRegistry';

import { AddShipmentItemsModal } from './ShipmentDetail/AddShipmentItemsModal/AddShipmentItemsModal';
import { DeleteShipmentModal } from './ShipmentDetail/DeleteShipmentModal';
import { RemoveItemModal } from './ShipmentDetail/ShipmentItemsList/RemoveItemModal';
import { ShipmentPackingSlipModal } from './ShipmentDetail/ShipmentPackingSlipModal';
import { NewShipmentModal } from './ShipmentsPage/NewShipmentModal';

export const [ShipmentModalProvider, useShipmentModals] = createModalRegistry({
  NewShipmentModal,
  DeleteShipmentModal,
  AddShipmentItemsModal,
  RemoveItemModal,
  ShipmentPackingSlipModal,
});
